"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageSize = void 0;
var getImageSize = function getImageSize(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      return reject('Window is not defined');
    }
    if (!url) {
      return reject('Url is not defined');
    }
    var timer = null;
    var img = new Image();
    img.addEventListener('load', function () {
      if (timer) {
        clearTimeout(timer);
      }
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight
      });
    });
    img.addEventListener('error', function (event) {
      if (timer) {
        clearTimeout(timer);
      }
      reject("".concat(event.type, ": ").concat(event.message));
    });
    img.src = url;
    if (options.timeout) {
      timer = setTimeout(function () {
        return reject('Timeout');
      }, options.timeout);
    }
  });
};
exports.getImageSize = getImageSize;